import { render } from "./CreateQuickQuotation.vue?vue&type=template&id=f6f4d76a&scoped=true"
import script from "./CreateQuickQuotation.vue?vue&type=script&lang=js"
export * from "./CreateQuickQuotation.vue?vue&type=script&lang=js"

import "./CreateQuickQuotation.vue?vue&type=style&index=0&id=f6f4d76a&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f4d76a"]])

export default __exports__